<template>
  <RouterView
    name="footer"
    class="grow"
    :class="{
      'container print:mx-0 print:min-w-full': !route.meta.width,
    }"
  />
  <div class="mt-2 flex justify-end">
    <VersionBadge class="badge-xl hidden rounded-r-none rounded-b-none md:flex" />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import VersionBadge from '../components/app/VersionBadge.vue';

const route = useRoute();
</script>
